import React from 'react';
import { useGlobalContext } from '../Context/GlobalContext';

export const SalaryHeader = ({ updateSalaryDetails, effectiveDate, salaryType, totalCTC, earnings, deductions, employerContributions, employeeContributions }) => {
  const { baseUrl, selectedStaff, openToast, setIsLoading, isLoading } = useGlobalContext();
  async function createORUpdateSalaryDetails(e) {
    setIsLoading(true);
    console.log(effectiveDate); 
    const data = {
      effective_date: effectiveDate + "-15", 
      salary_type: salaryType,
      ctc_amount: Number(totalCTC),
      employer_pf: employerContributions.pf.amount === "" ? 0 : Number(employerContributions.pf.amount),
      employer_esi: employerContributions.esi.amount === "" ? 0 : Number(employerContributions.esi.amount),
      employee_pf: employeeContributions.pf.amount === "" ? 0 : Number(employeeContributions.pf.amount),
      employee_esi: employeeContributions.esi.amount === "" ? 0 : Number(employeeContributions.esi.amount),
      employer_lwf: employerContributions.lwf.amount === "" ? 0 : Number(employerContributions.lwf.amount),
      employee_lwf: employeeContributions.lwf.amount === "" ? 0 : Number(employeeContributions.lwf.amount),
      employerContribution: employerContributions,
      employeeContribution: employeeContributions,
      earnings: earnings?.map((item) => ({
        heads: item?.name,
        calculation: item?.type || "On Attendance",
        amount: parseFloat(item?.amount),
      })),
      deductions: deductions?.map((item) => ({
        heads: item?.name,
        calculation: item?.type || "On Attendance",
        amount: parseFloat(item?.amount),
      })),
    };
    console.log(data);
    try {
      const response = await fetch(`${baseUrl}salary`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...data,
          staffId: selectedStaff?.staffDetails?.id,
        }),
      });

      console.log("Response from backend:", response);

      if (response.ok) {
        // Changed to response.ok to handle all 2xx responses
        const result = await response.json();
        console.log("Response data:", result);
        // Show success toast and close modal
        openToast("Salary details successfully updated or created", "success");
        updateSalaryDetails();
      } else {
        // Show error toast if response status is not 2xx
        openToast("An error occurred while adding or updating Salary", "error");
      }
    } catch (error) {
      console.error("Error submitting Salary:", error);
      openToast("An error occurred while adding or updating Salary", "error");
    } finally {
      setIsLoading(false);
    }
  }


  return (
    <div className="flex justify-between items-center w-full md:px-6 py-4">
      <h1 className="text-[20px] font-medium text-gray-900">Salary Details</h1>
      <button className="second-btn disabled:cursor-not-allowed disabled:opacity-50" onClick={createORUpdateSalaryDetails} disabled={isLoading}>
        Update Details
      </button>
    </div>
  );
};


